const PANEL_HEADER_HEIGHT = "77px";

export const videoQuestionsCss = {
  height: `calc(100% - ${PANEL_HEADER_HEIGHT})`,
  maxHeight: `calc(100% - ${PANEL_HEADER_HEIGHT})`,
  overflow: "hidden",
  position: "absolute",
  width: "100%",
};
